import cn from "classnames";
import { useMemo } from "react";

import { Select } from "src/shared/ui/Select";
import matchIcon from "src/assets/icons/matchIcon.svg";
import useStores from "src/hooks/useStores";

import { useStyles } from "./styles";

export const RoundSelect = ({ isMatch }) => {
    const classes = useStyles();
    const { lobbyStore } = useStores();
    const matchConfig = lobbyStore.matchConfig.value;
    const matchesArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    const roundOptions = useMemo(
        () =>
            matchesArray.map((val) => ({
                value: val,
                label: String(val),
                icon: <img src={matchIcon} className={classes.betSelectIcon} />,
            })),
        [matchesArray]
    );

    return (
        <Select<number>
            value={matchConfig}
            onChange={(value) => {
                lobbyStore.setMatchConfigValue(value);
            }}
            options={roundOptions}
            renderEmptyLabel={() => {
                return <div>Empty</div>;
            }}
            isMatch={isMatch}
            renderLabel={(option) => {
                return (
                    <div
                        className={cn(classes.betSelectLabelWrapper, {
                            prolimit: !isMatch,
                        })}
                    >
                        <div className={classes.betSelectLabelIcon}>
                            {option.icon}
                        </div>
                        <span
                            className={cn(classes.betSelectLabel, {
                                prolimit: !isMatch,
                            })}
                        >
                            {option.label}
                        </span>
                    </div>
                );
            }}
            renderOption={(option, selected) => {
                return (
                    <div
                        className={cn(classes.betOption, {
                            [classes.betOptionSelected]: selected,
                        })}
                    >
                        <div
                            className={cn(classes.betDropdownOptionIcon, {
                                [classes.betDropdownOptionIconSelected]:
                                    selected,
                            })}
                        >
                            {option.icon}
                        </div>
                        <span className={classes.betDropdownOptionLabel}>
                            {option.label}
                        </span>
                    </div>
                );
            }}
        />
    );
};
